import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Guitar, Search } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import api from '@/lib/api';
import { PublicHeader, PublicFooter } from '@/components/PublicShell';
import { BandStatusBadge } from '@/components/Badges';

export default function BandsListPage() {
  const [bands, setBands] = useState([]);
  const [settings, setSettings] = useState(null);
  const [query, setQuery] = useState('');
  const [filter, setFilter] = useState('todas');

  useEffect(() => {
    api.get('/public/bands').then((r) => setBands(r.data));
    api.get('/public/settings').then((r) => setSettings(r.data));
  }, []);

  const filtered = bands.filter((b) => {
    if (query && !b.name.toLowerCase().includes(query.toLowerCase())) return false;
    if (filter === 'todas') return true;
    return b.status === filter;
  });

  return (
    <div>
      <PublicHeader />
      <div className="mx-auto max-w-6xl px-4 sm:px-6 py-10">
        <div className="font-display text-4xl text-white">BANDAS PARTICIPANTES</div>
        <p className="text-muted-foreground mt-1">Conheça todas as bandas do Campeonato de Bandas do Pub Garage 66.</p>

        <div className="mt-6 flex flex-wrap items-center gap-3">
          <div className="relative flex-1 min-w-[220px]">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
            <Input
              data-testid="bands-search-input"
              placeholder="Buscar banda…"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              className="pl-9 bg-card border-border"
            />
          </div>
          <Tabs value={filter} onValueChange={setFilter}>
            <TabsList className="bg-card border border-border">
              <TabsTrigger value="todas" data-testid="filter-todas">Todas</TabsTrigger>
              <TabsTrigger value="participante">Ativas</TabsTrigger>
              <TabsTrigger value="classificada">Classificadas</TabsTrigger>
              <TabsTrigger value="eliminada">Eliminadas</TabsTrigger>
              <TabsTrigger value="campea">Campãs</TabsTrigger>
            </TabsList>
          </Tabs>
        </div>

        {filtered.length === 0 ? (
          <div className="text-center py-16 text-muted-foreground">Nenhuma banda encontrada.</div>
        ) : (
          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {filtered.map((b) => (
              <Link key={b.id} to={`/bandas/${b.slug}`} data-testid={`band-card-${b.slug}`}>
                <Card className="card-hover border border-border bg-card overflow-hidden h-full">
                  <div className="aspect-video bg-gradient-to-br from-[#1a1e2c] to-[#0b0c0f] flex items-center justify-center">
                    {b.logo_url ? (
                      <img src={b.logo_url} alt={b.name} className="w-full h-full object-cover" />
                    ) : (
                      <Guitar className="w-14 h-14 text-muted-foreground" />
                    )}
                  </div>
                  <CardContent className="p-4">
                    <div className="flex items-center justify-between gap-2">
                      <div className="font-display text-xl text-white">{b.name}</div>
                      <BandStatusBadge status={b.status} />
                    </div>
                    <div className="text-xs text-muted-foreground mt-1">{b.city}{b.state ? `/${b.state}` : ''}</div>
                    <div className="text-sm text-muted-foreground mt-2 line-clamp-2">{b.short_description}</div>
                  </CardContent>
                </Card>
              </Link>
            ))}
          </div>
        )}
      </div>
      <PublicFooter settings={settings} />
    </div>
  );
}
